import { useFormContext } from 'react-hook-form';
import { TPurposeOfBusinessRelations } from '~/modules/identification/forms/BusinessRelations/types.ts';
import { TradingInfo } from '~/modules/identification/forms/BusinessRelations/components/SecuritiesOperations/TradingInfo.tsx';
import { DepositoryInfo } from '~/modules/identification/forms/BusinessRelations/components/SecuritiesOperations/DepositoryInfo.tsx';

export const SecuritiesOperations = () => {
  const { watch } = useFormContext<TPurposeOfBusinessRelations>();
  const isSecuritiesOperations = watch('securitiesOperations');

  return (
    <>
      {isSecuritiesOperations && (
        <>
          <TradingInfo />
          <DepositoryInfo />
        </>
      )}
    </>
  );
};
